import type { FormQuizQuestion, FormQuizVerdict } from '@tunasong/music-lib'
import { Button } from '@tunasong/ui-lib'
import type { FC } from 'react'
import { useTheoryCopy } from '../theory-copy/use-theory-copy.js'
import styles from './form-quiz-feedback.module.css'

export interface FormQuizFeedbackProps {
  question: FormQuizQuestion
  verdict: FormQuizVerdict
  onHearAgain: () => void
  onNext: () => void
}

/**
 * Form ID Quiz feedback panel — verdict + lexicon-driven explainer + Hear
 * again / Next actions.
 *
 * Spec: docs/superpowers/specs/2026-05-23-form-visualizer-v1-design.md §8.2
 */
export const FormQuizFeedback: FC<FormQuizFeedbackProps> = props => {
  const { question, verdict, onHearAgain, onNext } = props
  const explainerCopy = useTheoryCopy('form-quiz-feedback')

  const correctName = question.entry.displayName

  return (
    <section className={styles.panel} aria-label="Quiz feedback">
      <div className={styles.verdictLine}>
        {verdict.correct ? (
          <span className={styles.correct}>Correct! That was {correctName}.</span>
        ) : (
          <span className={styles.incorrect}>Not quite — that was {correctName}.</span>
        )}
      </div>

      {explainerCopy?.body ? <p className={styles.explainer}>{explainerCopy.body}</p> : null}

      <div className={styles.actions}>
        <Button type="button" variant="outlined" onClick={onHearAgain}>
          Hear again
        </Button>
        <Button type="button" variant="contained" onClick={onNext}>
          Next
        </Button>
      </div>
    </section>
  )
}
